import { useState } from "react";
import { COURSES } from "@/data/content";
import { CourseCard, PageHero } from "@/components/site/ui";

const CATS = ["All", ...new Set(COURSES.map((c) => c.category))];

export default function Courses() {
  const [cat, setCat] = useState("All");
  const list = cat === "All" ? COURSES : COURSES.filter((c) => c.category === cat);
  return (
    <div data-testid="courses-page">
      <PageHero eyebrow="All Courses" title="Pick a skill," highlight="start today" text="Practical, beginner-friendly courses taught by women mentors. Every course includes projects, live doubt sessions and a certificate." />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10">
        <div className="flex flex-wrap gap-2 mb-10">
          {CATS.map((c) => (
            <button key={c} data-testid={`filter-${c.toLowerCase().replace(/\s/g, "-")}`} onClick={() => setCat(c)}
              className={`rounded-full px-5 py-2 text-sm font-semibold transition-[background-color,box-shadow] ${cat === c ? "bg-[var(--pink)] text-[var(--on-accent)] shadow-[0_0_18px_var(--glow-pink)]" : "glass"}`}>{c}</button>
          ))}
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
          {list.map((c, i) => <CourseCard key={c.slug} c={c} i={i} />)}
        </div>
      </div>
    </div>
  );
}
